import React from 'react'
import { Col } from 'react-bootstrap'
import { Filter } from 'components/Filter'
import * as S from './style'

interface SearchBarProps {
  searchTerm: string
  onChange: (value: string) => void
  onSearch: (value: string) => void
}

export const SearchBar = ({ searchTerm, onChange, onSearch }: SearchBarProps): JSX.Element => {
  return (
    <S.SearchRow>
      <Col md={6}>
        <S.FilterWrapper>
          <Filter
            currentSearchTerm={searchTerm}
            btnClick={onSearch}
            onFilterChange={onChange}
          />
        </S.FilterWrapper>
      </Col>
    </S.SearchRow>
  )
}
